import * as React from 'react';
import {RegisterUsernameScreenType} from '@practicegenius/register-account/src/screens/RegisterUsername';
import {IMT} from '@practicegenius/pg-util/src/StringUtils';
import {UsernameSelector} from '../../../components/UsernameSelector/UsernameSelector';
import {ProgressScreen} from '../../../components/screens/BaseScreen';

export const RegisterUsername: RegisterUsernameScreenType = ({
  lang,
  onFormSubmit,
  progress,
  actionButtons,
  usernameInputProps,
  firstName,
}) => (
  <form onSubmit={onFormSubmit}>
    <ProgressScreen
      helmetTitle={lang.pageTitle}
      headerTitle={lang.headerTitle}
      title={IMT(lang.title, {
        firstName,
      })}
      instructions={lang.instructions}
      progress={progress}
      actionButtons={[actionButtons.primary]}
      cancelProps={{href: '/'}}
    >
      <UsernameSelector
        name="username"
        value={usernameInputProps.value ?? ''}
        onChange={e => usernameInputProps.onChange(e.target.value)}
        suggesterProps={{suggestionCount: 6}}
        error={usernameInputProps.error}
        autoFocus
      />
    </ProgressScreen>
  </form>
);
